import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import ChannelButton from 'components/ChannelButton';
import ConfirmBottomSheet from 'components/ConfirmBottomSheet';
import { Desktop, Mobile } from 'components/Responsive';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { openURL } from 'utils/webViewUtils';

import { Container, CenteredImage, Header, Subheader } from '../../styles';
import {
  MobileFixedChannels,
  MobileChannelsContainer,
  DesktopChannelsContainer,
  DesktopCountryContainer,
  DesktopChannel,
  CountryName,
} from './styles';

const Help = () => {
  const { t } = useStoreTranslation();
  const [showWhatsappConfirm, setShowWhatsappConfirm] = useState<boolean>(false);
  const history = useHistory();

  const handleMailButtonClick = () => history.push('/corporate/login/confirm-email/help/email');
  const handleChatButtonClick = () => setShowWhatsappConfirm(true);
  const handleChatCancel = () => setShowWhatsappConfirm(false);
  const handleChatConfirm = () => {
    openURL(`https://wa.me/${t('login.confirmEmail.help.contact.whatsappNumber')}?text=`);
    setShowWhatsappConfirm(false);
  };
  const handlePhoneButtonClick = () => openURL(`tel:+${t('login.confirmEmail.help.contact.phoneNumber')}`);

  return (
    <Container>
      <Mobile>
        <CenteredImage marginTop={25} marginBottom={50} width={160} src="/corporate/images/logo-netviajes.svg" />
      </Mobile>

      <Header black>{t('login.confirmEmail.help.contact.title')}</Header>
      <Subheader>{t('login.confirmEmail.help.contact.subtitle')}</Subheader>

      <Desktop>
        <DesktopChannelsContainer>
          <DesktopCountryContainer>
            <CountryName>{t('login.confirmEmail.help.countries.brazil.name')}</CountryName>
            <DesktopChannel iconSrc="/corporate/images/mail.svg">
              <span>{t('login.confirmEmail.help.countries.brazil.email')}</span>
            </DesktopChannel>
            <DesktopChannel iconSrc="/corporate/images/phone.svg">
              <span>{t('login.confirmEmail.help.countries.brazil.phone')}</span>
            </DesktopChannel>
          </DesktopCountryContainer>

          <DesktopCountryContainer>
            <CountryName>{t('login.confirmEmail.help.countries.colombia.name')}</CountryName>
            <DesktopChannel iconSrc="/corporate/images/mail.svg">
              <span>{t('login.confirmEmail.help.countries.colombia.email')}</span>
            </DesktopChannel>
            <DesktopChannel iconSrc="/corporate/images/phone.svg">
              <span>{t('login.confirmEmail.help.countries.colombia.phone')}</span>
            </DesktopChannel>
          </DesktopCountryContainer>

          <DesktopCountryContainer>
            <CountryName>{t('login.confirmEmail.help.countries.mexico.name')}</CountryName>
            <DesktopChannel iconSrc="/corporate/images/mail.svg">
              <span>{t('login.confirmEmail.help.countries.mexico.email')}</span>
            </DesktopChannel>
            <DesktopChannel iconSrc="/corporate/images/phone.svg">
              <span>{t('login.confirmEmail.help.countries.mexico.phone')}</span>
            </DesktopChannel>
          </DesktopCountryContainer>
        </DesktopChannelsContainer>
      </Desktop>

      <Mobile>
        <MobileFixedChannels>
          <MobileChannelsContainer>
            <ChannelButton
              label={t('login.confirmEmail.help.contact.mail')}
              iconSrc="/corporate/images/mail-active.svg"
              onClick={handleMailButtonClick}
            />
            <ChannelButton
              label={t('login.confirmEmail.help.contact.chat')}
              iconSrc="/corporate/images/whatsapp-active.svg"
              onClick={handleChatButtonClick}
            />
            <ChannelButton
              label={t('login.confirmEmail.help.contact.phone')}
              iconSrc="/corporate/images/phone-active.svg"
              onClick={handlePhoneButtonClick}
            />
          </MobileChannelsContainer>
        </MobileFixedChannels>
      </Mobile>

      <ConfirmBottomSheet
        show={showWhatsappConfirm}
        onClose={handleChatCancel}
        onConfirm={handleChatConfirm}
        title={t('login.confirmEmail.help.contact.whatsappConfirm')}
      />
    </Container>
  );
};

export default Help;
